import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { Save } from "react-feather";
import { FilePlus } from "react-feather";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";

//FORM
import CreateEmpMovementForm from "./CreateEmpMovementForm";

interface ModalProps {
  EmpNo: string;
}

const CreateEmpMovementModal: React.FC<ModalProps> = ({ EmpNo }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <div className="d-flex justify-content-end">
        <Btn
          color="info"
          onClick={toggle}
          style={{ display: "flex", alignItems: "center", gap: "2px" }}
        >
          <FilePlus size={16} className="me-1" />
          Create Employment Movement
        </Btn>
      </div>

      <Modal
        size="xl"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Create Employment Movement</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Create a new employment movement for this employee.{" "}
              <b style={{ color: "red" }}>
                Please review all information carefully before proceeding
              </b>
              , as employment movements cannot be easily modified once created.
              If changes are required, please contact your HR Administrator.
            </P>
          </ModalHeader>
          <CreateEmpMovementForm EmpNo={EmpNo} toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};

export default CreateEmpMovementModal;
